module.exports = __webpack_public_path__ + "static/media/ic_paiming.f95d0ba2.svg";